import gql from "graphql-tag";

const SET_N_TS_SEEN = gql`
  mutation SetNTsSeen($timesheetID: Int!, $type: TimesheetNotificationsTypes!) {
    setNTsSeen(timesheetID: $timesheetID, type: $type)
  }
`;

export default SET_N_TS_SEEN;
